"use strict";
var router_1 = require("@angular/router");
var home_component_1 = require("./home/home.component");
var about_component_1 = require("./about/about.component");
var term_component_1 = require("./term/term.component");
var privacy_component_1 = require("./privacy/privacy.component");
var appRoutes = [
    { path: '', component: home_component_1.HomeComponent },
    { path: 'about', component: about_component_1.AboutComponent },
    { path: 'term', component: term_component_1.TermComponent },
    { path: 'privacy', component: privacy_component_1.PrivacyComponent }
];
exports.appRoutingProviders = [];
exports.routing = router_1.RouterModule.forRoot(appRoutes);



//////////////////
// WEBPACK FOOTER
// ./src/app/app.routing.ts
// module id = 35
// module chunks = 0